"use client";

import { type DependencyList, useEffect, useRef } from "react";

/**
 * A hook that provides a ref to track if the component is mounted,
 * passed to the effect callback.
 */
export function useSafeEffect(
    callback: (isMountedRef: React.MutableRefObject<boolean>) => void | (() => void),
    deps: DependencyList
) {
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        const cleanup = callback(isMountedRef);

        return () => {
            isMountedRef.current = false;
            if (typeof cleanup === "function") {
                cleanup();
            }
        };
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
